import { render, staticRenderFns } from "./systemCorporateAccount.vue?vue&type=template&id=bc45bb5e&scoped=true&"
import script from "./systemCorporateAccount.vue?vue&type=script&lang=js&"
export * from "./systemCorporateAccount.vue?vue&type=script&lang=js&"
import style0 from "./systemCorporateAccount.vue?vue&type=style&index=0&id=bc45bb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc45bb5e",
  null
  
)

export default component.exports